<div class="cloud-tags" *ngIf="clonedSelected?.length">
  <div class="cloud-tags__item" *ngFor="let item of clonedSelected; let i = index">
    <span class="cloud-tags__label">{{ item && item[bindLabel] }}</span>
    <button class="text-muted ml-2" aria-hidden="true" (click)="removeSelect(i)">
      <icon-times [style.width.px]="10" [style.height.px]="10"></icon-times>
    </button>
  </div>
</div>
